import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

import Tooltip from 'Pods/Shared/Tooltip'

import StatsNumber from '../StatsNumber'
import StatsCircular from '../StatsCircular'
import ReputationTooltip from './ReputationTooltip'

function Reputation({ data }) {
  const rep = data.reputation_in_last_7days
  // Color coding for Response Time. Below 6h - green, 6h-24h - yellow, 24h+ - red
  const respTimeClass = data.response_time < 6 ? 'is-positive'
    : (data.response_time > 24 ? 'is-negative' : 'is-neutral')
  // Color coding for Response Rate. Equals of above 85% - green, 60-84% - yellow, below 60% - red
  const respRateClass = data.response_rate >= 85 ? 'is-positive'
    : (data.response_rate < 60 ? 'is-negative' : 'is-neutral')
  // Format last 7 days reputation based on it's value
  const repFormat = rep > 0 ? (rep > 100 ? '+0.0a' : '+0') : '0'
  // Format total reputation
  const totalReputation = data.reputation < 10000 ? '0' : data.reputation < 100000 ? '0.0a' : '0a'

  return (
    <div>
      <div className="row">
        <div className="col-6 stats-circular">
          <StatsCircular
            value={data.reputation}
            maxValue={data.next_level_score ? data.next_level_score : data.reputation}
            displayValue={data.reputation}
            title="Total"
            format={totalReputation}
            tooltip={(
              <ReputationTooltip
                currentLevel={data.level}
                nextLevel={data.next_level}
                royalties={data.royalty_rate}
                currentRep={data.reputation}
                nextRep={data.next_level_score}
              />
            )}
            barColor="#19bcc9"
            barBgColor="#F7F7F7"
          />
        </div>
        <div className="col-6 stats-tooltip-container">
          <Tooltip
            tooltipClassName="tooltip--medium"
            id="dashboard__stats-reputation"
            content="Reputation you earned in a week."
            html
          >
            <div className="stats-element reputation-last-score">
              <div className="stats-element__value">
                <span className={rep > 0 ? 'is-positive' : rep < 0 ? 'is-negative' : ''}>
                  {numeral(rep).format(repFormat)}
                </span>
              </div>
              <div className="stats-element__title">Last 7 days</div>
            </div>
          </Tooltip>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="stats-separator-text stats-tooltip-container">&nbsp;</div>
        </div>
      </div>
      <div className="row stats-bottom-row">
        <div className="col-6 stats-tooltip-container">
          <Tooltip
            tooltipClassName="tooltip--medium"
            id="dashboard__stats-response-time"
            content="Response time shows customers how fast you respond to private messages. Answer messages
            quickly to attract more customers and boost your appeal."
          >
            <StatsNumber value={data.response_time} title="Response time" format="0.0[0]h" textColor={respTimeClass} />
          </Tooltip>
        </div>
        <div className="col-6 stats-tooltip-container">
          <Tooltip
            tooltipClassName="tooltip--medium"
            id="dashboard__stats-response-rate"
            content="Response rate shows customers how often you respond to private messages. Answer all
            messages to encourage customers to buy from you."
          >
            <StatsNumber value={data.response_rate/100} title="Response rate" format="0%" textColor={respRateClass} />
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

Reputation.propTypes = {
  data: PropTypes.shape({
    reputation: PropTypes.number.isRequired,
    level: PropTypes.string.isRequired,
    next_level: PropTypes.string,
    next_level_score: PropTypes.number,
    royalty_rate: PropTypes.number.isRequired,
    response_time: PropTypes.number.isRequired,
    response_rate: PropTypes.number.isRequired,

  }).isRequired,
}

export default Reputation
